import productInformationTypes from './product-information/types';

export default {
  ...productInformationTypes,
};
